import React, { Component, Fragment } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "../../../revvComponents";
import SharedDocumentRecipientWrapper from "../../SharedDocumentWrapper/SharedDocumentRecipientWrapper";
import RecipientThanksDeclinedPopup from "../../DocumentApprovalPopupNew/RecipientSidePopups/RecipientThanksDeclinedPopup";

class RecipientDocHeaderForward extends Component {
  state = {
    showDocumentForwarding: false,
    sucessPopup: false,
  };

  handleDocumentForward = (key, value) => {
    this.setState({
      [key]: value,
    });
  };

  _updateMultipleState = obj => {
    this.setState({
      ...obj,
    });
  };

  _onClose = () => {
    this.setState({
      sucessPopup: false,
    });
  };

  render() {
    return (
      <Fragment>
        {this.state.showDocumentForwarding && (
          <SharedDocumentRecipientWrapper
            sharingHash={this.props.sharingHash}
            updateMultipleState={this._updateMultipleState}
          />
        )}
        {this.state.sucessPopup && (
          <RecipientThanksDeclinedPopup
            view="ForwardedDocument"
            onClose={this._onClose}
          />
        )}
        <span className="recipientdocheader-forward-button right-border">
          <Button
            type="one"
            onClick={() =>
              this._updateMultipleState({
                showDocumentForwarding: true,
              })
            }
            tabIndex="0"
            onKeyDown={() => {}}
            className="analyse-document cta-doc-send-btn forward-doc-btn"
            data-test="quotation-draft-btns-send">
            <i>
              <FontAwesomeIcon icon={["far", "paper-plane"]} />
            </i>
            Forward document
          </Button>
        </span>
      </Fragment>
    );
  }
}

export default RecipientDocHeaderForward;
